module.exports = __webpack_public_path__ + "media/images/home/steps-42bd50bd0226241f64262f92bd18deaa.png";